import React from "react";

const ProofItem = ({ title, text }) => (
  <div className="proof-item">
    <div className="proof-title">{title}</div>
    <div className="proof-text">{text}</div>
  </div>
);

export default function ProofSection() {
  return (
    <section id="proof" className="proof-section">
      <div className="container py-5">
        <div className="text-center mb-4">
          <h2 className="text-uppercase">Experience & Engagement</h2>
          <p className="text-muted mb-0">
            Worked on business-critical platforms in payments, retail and high-traffic systems, including real-time transaction processing, external processor integrations and 24/7 production operations.
          </p>
        </div>

        <div className="proof-grid">
          <div className="proof-card">
            <div className="proof-badges">
              <span className="proof-badge">10+ years</span>
              <span className="proof-badge">24/7 production systems</span>
            </div>

            <div className="mt-2 mb-2 d-flex justify-content-center">
              <a
                rel="nofollow noopener noreferrer"
                href="https://www.exali.de/siegel/Alexander-Aprelkin"
                target="_blank"
                title="More about Alexander Aprelkin's IT liability insurance"
              >
                <img
                  src="https://www.exali.de/siegel/siegel_de-2_1c3b2964baab89ed5848c513b9a0accb.png"
                  width="90"
                  height="90"
                  alt="More about Alexander Aprelkin's IT liability insurance"
                  loading="lazy"
                />
              </a>
            </div>

            <ProofItem
              title="Education"
              text="M.Sc. Computer Science (Technical University of Munich)"
            />
            <ProofItem
              title="Certifications"
              text="iSAQB Certified Software Architect (Foundation), IBM DB2 Associate, Blockchain Developer (Udacity)."
            />
            <ProofItem
              title="How I create value"
              text="I join teams hands-on and work directly in the codebase and production environment. My focus is improving reliability, observability and integration stability in business-critical backend systems."
            />
          </div>

          <div className="proof-card">
            <div className="proof-kpis">
              <div className="kpi">
                <div className="kpi-v">Payments & transaction processing</div>
                <div className="kpi-k">Real-time routing, authorization flows, third-party processor integrations</div>
              </div>

              <div className="kpi">
                <div className="kpi-v">Production stabilization</div>
                <div className="kpi-k">Incident analysis, root cause, hardening (timeouts/retries/circuit breakers), runbooks</div>
              </div>

              <div className="kpi">
                <div className="kpi-v">Observability & operations</div>
                <div className="kpi-k">Metrics/logs/tracing, alert quality, dashboards, on-call support workflows</div>
              </div>

              <div className="kpi">
                <div className="kpi-v">Cloud & platform</div>
                <div className="kpi-k">Kubernetes, Docker, CI/CD, performance and scaling in distributed systems</div>
              </div>

              <div className="kpi">
                <div className="kpi-v">Engagement</div>
                <div className="kpi-k">Munich / Remote · Time & Material (preferred) · Fixed scope by agreement</div>
              </div>
            </div>


            <div className="proof-footer">
              <a href="#contact" className="btn btn-outline-light">Discuss your project</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
